import {
  setReportedAPI,
  setReportedTwoAPI,
  setReportedThreeAPI,
} from '@/axios/home'
export default {
  // 资源点击上报
  setReporte(type, post_id, resources_type, resources) {
    // type 1-文章 2-视频
    // post_id 帖子file_id
    // resources_type 资源类型 1-文件 2-合集
    // resources: fshort,
    setReportedAPI({
      type,
      post_id,
      resources_type,
      resources,
    })
      .then(res => {})
      .catch(e => {})
  },
  // 老项目埋点接口
  setReporteTwo(event_id) {
    setReportedTwoAPI({
      event_id,
    })
      .then(res => {})
      .catch(e => {})
  },
  // 老项目埋点接口
  setReporteThree(channel, orderId, msg) {
    setReportedThreeAPI({
      channel: channel,
      id: orderId ? orderId : '',
      msg: msg ? msg : '',
    })
      .then(res => {})
      .catch(e => {})
  },
}
